export default __webpack_public_path__ + "static/media/c002-PPII-10.a4e1a505.svg";